import {RootState} from '@/store'
import {ActionTree} from 'vuex'
import {RequestPayload, ServiceApi} from '@payroll/optimus-common'
import {AuthorizationState} from '@/store/modules/authorization/index'

export const actions: ActionTree<AuthorizationState, RootState> = {

    logout: ({commit, dispatch, state}: any, {requestorCallback}: RequestPayload) => {
        new ServiceApi()
            .setToken(state.accessToken)
            .setBaseApi('/auth')
            .setRequestName('logout')
            .get(requestorCallback)
    }
}